<template>
  <div
    class="countdown-container clearfix"
    :style="{ paddingBottom: padding + 'px', paddingLeft: padding + 'px' }"
  >
    <span>{{ label }}</span>
    <CountDown class="CountDown" :class="{ noStart: !activityState }" :time="time" v-if="time">
      <template #default="timeData">
        <span class="label" style="color: #333" v-show="timeData.days"
          >{{ timeData.days }}天</span
        >
        <span class="value">{{ timeData.hours | addZero }}</span>
        <span class="label">:</span>
        <span class="value">{{ timeData.minutes | addZero }}</span>
        <span class="label">:</span>
        <span class="value">{{ timeData.seconds | addZero }}</span>
      </template>
    </CountDown>
  </div>
</template>

<script>
import { CountDown } from "vant";
export default {
  components: { CountDown },
  props: {
    startTime: {
      type: String,
      default: null,
    },
    endTime: {
      type: String,
      default: null,
    },
    padding: {
      type: Number,
      default: 16,
    },
  },
  data() {
    return {
      label: null,
      time: null,

      activityState: true
    };
  },
  created() {
    this.calc();
    this.setTime();
  },
  filters: {
    addZero(val) {
      return val < 10 ? `0${val}` : val;
    },
  },
  methods: {
    setTime() {
      setTimeout(this.calc, 1000);
    },
    calc() {
      const time1 = this.dayjs();
      const time2 = this.dayjs(this.startTime);
      const time3 = this.dayjs(this.endTime);
      if (time3 < time1) {
        this.label = "已结束";
        this.time = null;
        this.$emit('activityStateChange', true)
        this.activityState = true
      } else if (time2 > time1) {
        // 预告中
        this.label = "距开始:";
        this.time = time2 - time1;
        this.$emit('activityStateChange', false)
        this.activityState = false
      } else {
        this.label = "距结束:";
        this.time = time3 - time1;
        this.$emit('activityStateChange', true)
        this.activityState = true
      }
      this.setTime();
    },
  },
};
</script>

<style lang="less" scoped>
.countdown-container {
  padding-bottom: 32px;
  padding-left: 32px;
  & > span {
    float: left;
    font-size: 24px;
    font-weight: 400;
    color: #333333;
    line-height: 36px;
    margin-right: 4px;
  }
  .CountDown {
    display: flex;
    float: left;
    &.noStart .value {
      background-color: #44D7B6;
    }
  }
  .label {
    font-size: 24px;
    line-height: 36px;
  }
  .value {
    display: inline-block;
    background-color: #e82035;
    border-radius: 10px;
    width: 36px;
    height: 36px;
    font-size: 20px;
    line-height: 36px;
    color: #fff;
    text-align: center;
    margin: 0 4px;
    &.days {
      background-color: transparent;
      color: #333;
    }
  }
}
</style>